const SURVEY_GRID_PAGE_SIZE = 12;
const SURVEY_MINIMUM_TARGET_SIZE = 30;
const SURVEY_MINIMUM_AI_TARGET_SIZE = 100;
const MINIMUM_ANSWER_COUNT = 2;
const INVALID_IMAGES_FOR_HUMAN_COUNT_ERROR = 'If you are running an image test, your human panel count needs to be greater than zero.';
const DEFAULT_ANSWER_TITLE = 'Untitled_Answer';

export { SURVEY_GRID_PAGE_SIZE, SURVEY_MINIMUM_TARGET_SIZE, SURVEY_MINIMUM_AI_TARGET_SIZE, MINIMUM_ANSWER_COUNT, INVALID_IMAGES_FOR_HUMAN_COUNT_ERROR, DEFAULT_ANSWER_TITLE };
